/* Reusable fn for validating Texting Setup `checkNumAvailable` response */
export default function numAvailable (rs) {
  return (rs || null) === null ||
      (rs.data || null) === null ||
      (rs.data.data || null) === null ||
      !rs.data.data.length === 0 ||
      !rs.data.data[0];
}

// TODO - relocate on site retrofit
